import React from 'react'
import TextInput from '../TextInput'
import classes from './AddFriends.scss'
import GameItem from '../GameList/GameItem'
import GameListClasses from '../GameList/GameList.scss'
import 'whatwg-fetch'

class AddFriends extends React.Component {
  constructor (props) {
    super(props)

    const self: any = this
    self.state = { users: [] }

    self.findFriends = self.findFriends.bind(self)
    self.keySend = self.keySend.bind(self)
  }

  keySend (e) {
    if (e.keyCode === 13) { this.findFriends() }
  }

  findFriends () {
    const username = document.getElementById('searchuser').value
    const { baseUrl } = this.props
    fetch(`${baseUrl}/user/search`, {
      method: 'POST',
      body: JSON.stringify({ username }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          this.setState({ users: res.users })
        } else {
          alert('something went wrong')
        }
      })
  }

  renderUser (user) {
    return (<GameItem key={user.id} second={user.username} third='' onClick={() => window.location.href=`/profile/${user.username}`} />)
  }

  render () {
    const { users } = this.state

    return (<div className={classes.addFriends} style={{marginTop: '2em'}}>
      <h4>Search for friends: </h4>
      <TextInput id='searchuser' placeholder='Username' onKeyUp={this.keySend} />
      <hr />
      {users.length > 0 && <ul>{users.map(u => this.renderUser(u))}</ul>}
    </div>)
  }
}

export default AddFriends



/** WEBPACK FOOTER **
 ** ./src/components/Friends/AddFriends.js
 **/